// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

type MutationOptions = {
  variables: {
    input: {
      id: string,
    },
  },
};

const mutation = graphql`
  mutation DeleteItemMutation($input: DeleteItemInput!) {
    deleteItem(input: $input) {
      deletedId
    }
  }
`;

export default {
  commit: (options: MutationOptions) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_DELETE',
          parentID: ROOT_ID,
          connectionKeys: [{ key: 'PaginatedItemsContainer_items' }],
          pathToConnection: [ROOT_ID, 'items'],
          deletedIDFieldName: 'deletedId',
        },
      ],
    });
  },
};
